import { useCallback, useEffect } from 'react'

import { setPaymentAlertError } from 'src/Redux/payment-process'
import { PaymentErrors } from 'src/Components/PaymentErrorsAlert'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { updateCampaignPrice } from 'src/Redux/schedule-process/audienceTiktokSlice'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { getScheduledTikTokCampaign } from 'src/Redux/schedule-process/tiktokCampaign/selectors'

import { roundPriceValue } from '../../SpotifySchedulePage/helpers/helpers'

import { useChangeStartDate } from './useChangeStartDate'

export enum PaymentStatusEnum {
  SUCCESS = 'success',
  FAILURE = 'failure',
  ERROR = 'error',
}

export const useBackFromPaymentPageTikTok = (): void => {
  const dispatch = useAppDispatch()
  const scheduledTikTokCampaign = useAppSelector(getScheduledTikTokCampaign)
  const { search } = useCustomSearchParams()
  const { handleChangeDate } = useChangeStartDate()

  const urlStartDate = search.get('startDate')
  const errorType = search.get('errorType')
  const paymentStatus = search.get('paymentStatus')
  const urlBudget = search.get('budget')
  const baToken = search.get('ba_token')

  const roundedBudget = roundPriceValue(urlBudget || 0)

  const isBackFromPaymentPageWithError = Boolean(
    paymentStatus === PaymentStatusEnum.ERROR && !baToken && urlStartDate,
  )

  const isBackFromPaymentPageWithoutError = Boolean(
    paymentStatus === PaymentStatusEnum.FAILURE && urlStartDate,
  )

  const handleBackFromPaymentPage = useCallback(() => {
    if (isBackFromPaymentPageWithError) {
      dispatch(
        setPaymentAlertError(
          (errorType as PaymentErrors) || PaymentErrors.DEFAULT,
        ),
      )
    }

    if (!scheduledTikTokCampaign.startDate && urlStartDate) {
      handleChangeDate(urlStartDate)
    }

    dispatch(updateCampaignPrice(roundedBudget))
  }, [
    dispatch,
    errorType,
    handleChangeDate,
    isBackFromPaymentPageWithError,
    roundedBudget,
    scheduledTikTokCampaign.startDate,
    urlStartDate,
  ])

  useEffect(() => {
    if (isBackFromPaymentPageWithoutError || isBackFromPaymentPageWithError) {
      handleBackFromPaymentPage()
    }

    if (paymentStatus === PaymentStatusEnum.FAILURE) {
      dispatch(updateCampaignPrice(roundedBudget))
    }
  }, [
    dispatch,
    handleBackFromPaymentPage,
    isBackFromPaymentPageWithError,
    isBackFromPaymentPageWithoutError,
    paymentStatus,
    roundedBudget,
  ])
}
